module.exports = __webpack_public_path__ + "img/douban.bd72f389.png";